import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[ogFileDrop]',
  standalone: true,
})
export class FileDropDirective {
  @Output() filesDropped = new EventEmitter<FileList>();
  @Output() filesHovered = new EventEmitter<boolean>();

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    this.filesDropped.emit(event.dataTransfer.files);
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: Event) {
    event.preventDefault();
    this.filesHovered.emit(true);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: Event) {
    event.preventDefault();
    this.filesHovered.emit(false);
  }
}
